import { Component, inject } from '@angular/core';
import { Auth } from '../../services/auth';
import { Button } from '../../components/button/button';

@Component({
  selector: 'app-login',
  imports: [Button],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  private readonly auth = inject(Auth);
  
  protected login() {
    this.auth.login();
  }
}
